import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=8f2fd092"
import script from "./Reception.ts?vue&type=script&lang=ts&external"
export * from "./Reception.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports